const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'Anonymous') // needed to avoid cross-origin issues on CodeSandbox
    image.src = url
  })

// function getRadianAngle(degreeValue) {
//   return (degreeValue * Math.PI) / 180
// }

async function getFilterValue(name) {
  // console.log(name)
  switch (name) {
    case 'filter-normal':
      return 'sepia(0) contrast(1) grayscale(0) saturate(1) hue-rotate(0deg) brightness(1)';
    case 'filter-aden':
      return 'sepia(0.2) brightness(1.15) saturate(1.4)';
    case 'filter-amaro':
      return 'sepia(0.35) contrast(1.1) brightness(1.2) saturate(1.3)';
    case 'filter-ashby':
      return 'sepia(0.5) contrast(1.2) saturate(1.8)';
    case 'filter-brannan':
      return 'sepia(0.4) contrast(1.25) brightness(1.1) saturate(.9) hue-rotate(-2deg)';
    case 'filter-brooklyn':
      return 'sepia(0.25) contrast(1.25) brightness(1.25) hue-rotate(5deg)';
    case 'filter-charmes':
      return 'sepia(0.25) contrast(1.25) brightness(1.25) saturate(1.35) hue-rotate(-5deg)';
    case 'filter-clarendon':
      return 'sepia(0.15) contrast(1.25) brightness(1.25) hue-rotate(5deg)';
    case 'filter-crema':
      return 'sepia(0.5) contrast(1.25) brightness(1.15) saturate(.9) hue-rotate(-2deg)';
    case 'filter-dogpatch':
      return 'sepia(0.35) saturate(1.1) contrast(1.5)';
    case 'filter-earlybird':
      return 'sepia(0.25) contrast(1.25) brightness(1.15) saturate(.9) hue-rotate(-5deg)';
    case 'filter-gingham':
      return 'contrast(1.1) brightness(1.1)';
    case 'filter-ginza':
      return 'sepia(.25) contrast(1.15) brightness(1.2) saturate(1.35) hue-rotate(-5deg)';
    case 'filter-helena':
      return 'sepia(.5) contrast(1.05) brightness(1.05) saturate(1.35)';
    case 'filter-inkwell':
      return 'brightness(1.25) contrast(.85) grayscale(1)';
    case 'filter-kelvin':
      return 'sepia(.15) contrast(1.5) brightness(1.1) hue-rotate(-10deg)';
    case 'filter-lark':
      return 'sepia(.25) contrast(1.2) brightness(1.3) saturate(1.25)';
    case 'filter-lofi':
      return 'saturate(1.1) contrast(1.5)';
    case 'filter-maven':
      return 'sepia(.35) contrast(1.05) brightness(1.05) saturate(1.75)';
    case 'filter-mayfair':
      return 'contrast(1.1) brightness(1.15) saturate(1.1)';
    case 'filter-moon':
      return 'brightness(1.4) contrast(.95) saturate(0) sepia(.35);';
    case 'filter-perpetua':
      return 'contrast(1.1) brightness(1.25) saturate(1.1)';
    case 'filter-poprocket':
      return 'sepia(.15) brightness(1.2)';
    case 'filter-reyes':
      return 'sepia(.75) contrast(.75) brightness(1.25) saturate(1.4)';
    case 'filter-rise':
      return 'sepia(.25) contrast(1.25) brightness(1.2) saturate(.9)';
    case 'filter-sierra':
      return 'sepia(.25) contrast(1.5) brightness(.9) hue-rotate(-15deg)';
    case 'filter-skyline':
      return 'sepia(.15) contrast(1.25) brightness(1.25) saturate(1.2)';
    case 'filter-stinson':
      return 'sepia(.35) contrast(1.25) brightness(1.1) saturate(1.25)';
    case 'filter-slumber':
      return 'sepia(.35) contrast(1.25) saturate(1.25)';
    case 'filter-willow':
      return 'brightness(1.2) contrast(.85) saturate(.05) sepia(.2)';
    case 'filter-xpro-ii':
      return 'sepia(.45) contrast(1.25) brightness(1.75) saturate(1.3) hue-rotate(-5deg)';
    case 'filter-walden':
      return 'sepia(.35) contrast(.8) brightness(1.25) saturate(1.4)';
    case 'filter-vesper':
      return 'sepia(.35) contrast(1.15) brightness(1.2) saturate(1.3)';
    case 'filter-valencia':
      return 'sepia(.25) contrast(1.1) brightness(1.1)';
    case 'filter-toaster':
      return 'sepia(.25) contrast(1.5) brightness(.95) hue-rotate(-15deg)';
    case 'filter-sutro':
      return 'sepia(.4) contrast(1.2) brightness(.9) saturate(1.4) hue-rotate(-10deg)';
    default:
      return '';
  }
}

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {number} rotation - optional rotation parameter
 */
export default async function getCroppedImg(imageSrc, pixelCrop, rotation = 0, filterClass = 'filter-normal', customFilter = '') {
  // console.log("Hello", imageSrc)

  const image = await createImage(imageSrc)
  let filter;
  // console.log(image.width,image.height);
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const maxSize = Math.max(image.width, image.height)

  // console.log(image)
  const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2))

  // set each dimensions to double largest dimension to allow for a safe area for the
  // image to rotate in without being clipped by canvas context
  canvas.width = safeArea
  canvas.height = safeArea
  // console.log(canvas)
  // translate canvas context to a central location on image to allow rotating around the center.
  // ctx.translate(safeArea / 2, safeArea / 2)
  // ctx.rotate(getRadianAngle(rotation))
  // ctx.translate(-safeArea / 2, -safeArea / 2)

  if (filterClass === 'filter-custom') {
    filter = customFilter
  } else {
    filter = await getFilterValue(filterClass)
  }

  ctx.filter = filter

  // draw rotated image and store data.
  ctx.drawImage(
    image,
    safeArea / 2 - image.width * 0.5,
    safeArea / 2 - image.height * 0.5
  )

  const data = ctx.getImageData(0, 0, safeArea, safeArea)

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = 1920
  canvas.height = 1080

  // paste generated rotate image with correct offsets for x,y crop values.
  ctx.putImageData(
    data,
    Math.round(0 - safeArea / 2 + image.width * 0.5 ),
    Math.round(0 - safeArea / 2 + image.height * 0.5)
  )

  // As Base64 string
  return canvas.toDataURL('image/jpeg');

  // As a blob
  // return new Promise(resolve => {
  //   canvas.toBlob(file => {
  //     resolve(URL.createObjectURL(file))
  //   }, 'image/jpeg')
  // })
}